<template>
  <div class="security-code-wrap">
    <label :for="`code-${uuid}`" style="width: 100%">
      <ul :class="`${theme}-container security-code-container`">
        <li
          class="field-wrap"
          v-for="(item, index) in length"
          :key="index"
          :class="{
            cursor: index == value.length && focusing,
            cursorLast:
              length == value.length && focusing && index == length - 1,
          }"
        >
          <i class="char-field">{{ value[index] || placeholder }}</i>
        </li>
      </ul>
    </label>
    <!-- @keyup="handleInput($event)" 弃用：无法监听到复制粘贴，导致vue无法拦截数据变化 -->
    <input
      ref="input"
      class="input-code"
      v-model="values"
      :id="`code-${uuid}`"
      :name="`code-${uuid}`"
      type="tel"
      :maxlength="length"
      autocorrect="off"
      autocomplete="off"
      autocapitalize="off"
      @focus="canFocusing(true)"
      @blur="canFocusing()"
    />
  </div>
</template>

<script>
export default {
  name: "SecurityCode",
  props: {
    length: {
      type: Number,
      default: 4,
    },
    placeholder: {
      type: String,
      default: "-",
    },
    theme: {
      type: String,
      default: "block",
    },
    value: {
      type: String | Number,
    },
  },
  // variables
  data() {
    return {
      values: "",
      focusing: false,
    };
  },
  computed: {
    uuid() {
      return Math.random().toString(36).substring(3, 8);
    },
  },
  watch: {
    value(val) {
      this.values = val;
    },
    values(val) {
      this.$emit("input", val);
      if (val.length >= this.length) {
        this.hideKeyboard();
      }
    },
  },
  methods: {
    focusInput() {
      this.$nextTick(() => {
        this.$refs.input.focus();
      });
    },
    canFocusing(can) {
      console.log(1234);
      this.focusing = can;
    },
    hideKeyboard() {
      this.$emit("inputEnd", this.values);
      // 输入完成隐藏键盘
      document.activeElement.blur(); // ios隐藏键盘
      this.$refs.input.blur(); // android隐藏键盘
    },
  },
};
</script>

<style scoped lang="less">
.security-code-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
}

.security-code-container {
  margin: 0;
  padding: 0;
  display: flex;
  .field-wrap {
    list-style: none;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 2.75rem;
    width: 2.75rem;
    font-size: 1.25rem;
    .char-field {
      font-style: normal;
    }

    &.cursor {
      position: relative;
      &::after {
        position: absolute;
        content: "";
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 0.125rem;
        height: 1.25rem;
        background: #00e3f9;
        animation: flicker 1s infinite;
      }

      @keyframes flicker {
        to {
          opacity: 0;
        }

        from {
          opacity: 1;
        }
      }
    }
  }
}

.block-container {
  justify-content: space-between;
  .field-wrap {
    background: #002748;
    border: 1px solid rgba(0, 227, 249, 0.5);
    border-radius: 0.5rem;
    color: #e6e9ed;
  }
}

.line-container {
  position: relative;
  background-color: #fff;
  &:after {
    box-sizing: border-box;
    content: "";
    width: 200%;
    height: 200%;
    transform: scale(0.5);
    position: absolute;
    border: 1px solid #d9d9d9;
    top: 0;
    left: 0;
    transform-origin: 0 0;
    border-radius: 4px;
  }
  .field-wrap {
    flex: 1;
    position: relative;
    &:not(:last-child):after {
      content: "";
      width: 1px;
      height: 50%;
      position: absolute;
      right: 0;
      top: 25%;
      background-color: #d9d9d9;
      transform: scaleX(0.5);
    }
  }
}

.input-code {
  position: absolute;
  left: -9999px;
  top: -9999px;
}
</style>


// WEBPACK FOOTER //
// src/components/SecurityCode.vue